import React from 'react'
import MainSection from '../components/TermsConditions/MainSection'
import TermsAndConditions from '../components/TermsConditions/TermsAndConditions'

const TermsConditionsPage = () => {
  return (
    <>
        <MainSection/>
        <TermsAndConditions/>
    </>
  )
}

export default TermsConditionsPage